import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const updateRequestTicket = createAsyncThunk("AgentRequests/updateRequestTicket", async (data, thunkAPI) => {
  let { schema, handleSuccess, handleError } = data;
  try {
    const resp = await axios.put(`${process.env.REACT_APP_BASE_URL}api/agent-ticket/${data.ticketId}`, schema, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (handleSuccess) {
      handleSuccess();
    }
    return {...resp.data,schema};
  } catch (error) {
    if (error.response) {
      if (handleError) {
        handleError(error.response.data.errorMessage || error.response.data.message);
      }
      return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
    } else {
      if (handleError) {
        handleError(error.message);
      }
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
